<template>
    <Dialog style="display: flex; overflow-x:auto;" modal :header="'Editar ' + datos.datos.nombre" :style="{ width: '1600px'}">
        <div class="row">
            <div class="col-md-4" style="display: grid; grid-template-rows: 2fr 1fr;">
                <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">Datos</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="nombre">Nombre</label>
                            <input class="form-control" style="width: 100%;" v-model="nombre" type="text" id="nombre">
                        </div>
                        <div style="margin: 15px 0;">
                            <label for="tipo">Tipo</label>
                            <span style="margin-left: 10px;">{{ datos.datos.tipo }}</span>
                        </div>
                        <div style="display: flex;">
                            <div class="form-group">
                                <label for="fecha_inicio">Fecha inicio</label>
                                <Calendar dateFormat="dd/mm/yy" style="width: 100%;" v-model="fechaInicioDate"/>
                            </div>
                            <div class="form-group" style="margin-left: 15px;">
                                <label for="fecha_fin">Fecha fin</label>
                                <Calendar dateFormat="dd/mm/yy" style="width: 100%;" v-model="fechaFinDate"/>
                            </div>
                        </div>
                        <div>
                            <button @click="guardarDatos" class="btn btn-success" style="width: 100%;">Guardar</button>
                        </div>
                    </div>
                </div>
                <div class="card card-warning">
                    <div class="card-header">
                        <h3 class="card-title">Descargar</h3>
                    </div>
                    <div class="card-body">
                        <button @click="descargar" class="btn btn-default" style="width: 100%;">Descargar baremo</button>
                    </div>
                </div>
            </div>
            <div class="col-md-1"></div>
            <div class="card card-danger col-md-7">
                <div class="card-header">
                    <h3 class="card-title">Importar</h3>
                </div>
                <div class="card-body">
                    <div style="display: grid; gap: 15px;">
                        <div>
                            <div style="display: flex; gap: 5px">
                                <b>1º</b>
                                <p style="margin: 0;">Generar Excel con el siguiente formato:</p>
                            </div>
                            <img src="@/assets/img/importBaremo.png" alt="">
                            <p style="margin: 0;">Siendo:</p>
                            <li><span>Columna A= Gremio</span></li>
                            <li><span>Columna B= Código del trabajo </span></li>
                            <li><span>Columna C= Descripción del trabajo </span></li>
                            <li><span>Columna D= Tarifa compañía </span></li>
                            <li><span>Columna E= Tarifa operario </span></li>
                        </div>
                        <div style="display: flex; gap: 5px">
                            <b>2º</b>
                            <p style="margin: 0;">Guardar el fichero como "Tipo de archivo"->"CSV delimitado por comas"</p>
                        </div>
                        <div>
                            <div style="display: flex; gap: 5px">
                                <b>3º</b>
                                <p style="margin: 0;">Antes de subir:</p>
                            </div>
                            <div style="display: grid; gap: 10px;">
                                <select class="form-control form-control-sm" style="width: 350px;" v-model="eliminar_seleccionado">
                                    <option value="">-----</option>
                                    <option value="todo">Eliminar todo el baremo actual</option>
                                    <option value="cliente">Eliminar baremo a Cliente</option>
                                    <option value="operario">Eliminar baremo a Operario</option>
                                </select>
                                <select v-if="eliminar_seleccionado != 'todo'" class="form-control form-control-sm" style="width: 350px;" v-model="eliminar_especialidades_seleccionado">
                                    <option value="">-----</option>
                                    <option value="todo">Eliminar todas las especialidades</option>
                                    <option value="csv">Solo las especialidades del CSV</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div style="display: flex; gap: 5px">
                                <b>4º</b>
                                <p style="margin: 0;">Subir el fichero guardado:</p>
                            </div>
                            <FileUpload mode="basic" :maxFileSize="20000000" @select="subirarchivo($event)" chooseLabel="Elegir Archivo" />
                        </div>
                        <div style="margin-top: 10px;">
                            <button class="btn btn-primary" @click="importar">Importar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-secondary col-md-12">
            <div class="card-header">
                <h3 class="card-title">Trabajos</h3>
            </div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <h3>Nuevo</h3>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table-sm">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Cód. Relación</th>
                                        <th>Nombre</th>
                                        <th>Precio Cl.</th>
                                        <th>Precio Oper.</th>
                                        <th>Precio libre</th>
                                        <th>Solo Oper.</th>
                                        <th>App.</th>
                                        <th>Cantidad fija</th>
                                        <th>Tipo.</th>
                                        <th>Especialidad</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input class="form-control form-control-sm" style="width: 140px;" v-model="codigo" type="text"></td>
                                        <td><input class="form-control form-control-sm" style="width: 120px;" v-model="codrel" type="text"></td>
                                        <td><input class="form-control form-control-sm" style="width: 190px;" v-model="nomtr" type="text"></td>
                                        <td><input class="form-control form-control-sm" style="width: 120px;" v-model="preciocl" type="text"></td>
                                        <td><input class="form-control form-control-sm" style="width: 120px;" v-model="preciooper" type="text"></td>
                                        <td><input v-model="preciolibre" type="checkbox"></td>
                                        <td><input v-model="solooper" type="checkbox"></td>
                                        <td v-if="operario_factura_app"><input v-model="app" type="checkbox"></td>
                                        <td><input class="form-control form-control-sm" style="width: 120px;" v-model="cantidad" type="text"></td>
                                        <td v-if="mostrar_tipo_trabajo_realizado">
                                            <select class="form-control form-control-sm" v-model="tipo" id="">
                                                <option value="">---</option>
                                                <option value="MAT">MAT</option>
                                                <option value="MO">MO</option>
                                                <option value="DES">DES</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select class="form-control form-control-sm" v-model="especialidad">
                                                <option value="">Seleccionar</option>
                                                <option v-for="especialidad in especialidades" :key="especialidad.id" :value="especialidad.id">{{ especialidad.nombre }}</option>
                                            </select>
                                        </td>
                                        <td><button @click="anadirTrabajo" class="btn btn-success">Añadir</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-end align-items-center mb-3" style="gap: 15px;">
                <div>
                    <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="marcarTodas">Marcar todas precio libre</button>
                </div>
                <div style="display: flex; align-items: center;">
                    <div>
                        <label style="margin: 0;" for="buscar">Buscar: </label>
                    </div>
                    <div style="margin-left: 10px;">
                        <input type="search" name="buscar" class="form-control form-control-sm" v-model="globalFilter" aria-controls="tabla_chat"> 
                    </div>
                </div>
            </div>
            <DataTable 
            stripedRows
            v-model:filters="filters" 
            :value="trabajosFiltrados"
            responsiveLayout="scroll"
            paginator 
            :rows="20" 
            dataKey="idtrabajo" 
            :globalFilterFields="['codigo', 'nombre', 'nombre_especialidad']">
            
                <template #empty> No hay baremos disponibles. </template>

                <!-- Column Definitions -->
                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Código</strong>
                            <button @click="toggleOrden('codigo')" :aria-sort="codigoOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                <i :class="codigoIcon"></i>
                            </button>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <input class="form-control form-control-sm" style="width: 140px;" v-model="codigotr[data.idtrabajo]" type="text">
                    </template>
                </Column>
                
                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Cod. Relación</strong>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <input class="form-control form-control-sm" style="width: 120px;" v-model="codreltr[data.idtrabajo]" type="text">
                    </template>
                </Column>
                
                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Nombre</strong>
                            <button @click="toggleOrden('nombre')" :aria-sort="nombreOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                <i :class="nombreIcon"></i>
                            </button>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <div style="width: 190px;">
                            {{ data.nombre }}
                        </div>
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Precio Cl.</strong>
                        </div>
                    </template>
                    <template  #body="{ data }">
                        <input class="form-control form-control-sm" style="width: 120px;" v-model="preciocltr[data.idtrabajo]" type="text">
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Precio Oper.</strong>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <input class="form-control form-control-sm" style="width: 120px;" v-model="precioopertr[data.idtrabajo]" type="text">
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Precio libre</strong>
                        </div>
                    </template>
                    <template style="text-align: center;" #body="{ data }">
                        <input v-model="preciolibretr[data.idtrabajo]" type="checkbox">
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Spolo Oper.</strong>
                        </div>
                    </template>
                    <template style="text-align: center;" #body="{ data }">
                        <input v-model="soloopertr[data.idtrabajo]" type="checkbox">
                    </template>
                </Column>

                <Column v-if="operario_factura_app">
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>App</strong>
                        </div>
                    </template>
                    <template style="text-align: center;" #body="{ data }">
                        <input v-model="apptr[data.idtrabajo]" type="checkbox">
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Cantidad fija</strong>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <input class="form-control form-control-sm" style="width: 120px;" v-model="cantidadtr[data.idtrabajo]" type="text">
                    </template>
                </Column>

                <Column v-if="mostrar_tipo_trabajo_realizado">
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Tipo</strong>
                        </div>
                    </template>
                    <template #body="{ data }">
                        <select class="form-control form-control-sm" v-model="tipotr[data.idtrabajo]" id="">
                            <option value="">---</option>
                            <option value="MAT">MAT</option>
                            <option value="MO">MO</option>
                            <option value="DES">DES</option>
                        </select>
                    </template>
                </Column>

                <Column>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <strong>Especialidad</strong>
                        </div>
                    </template>
                    <template style="text-align: center;" #body="{ data }">
                        {{ data.nombre_especialidad}}
                    </template>
                </Column>

                <Column>
                    <template #header>
                    </template>
                    <template #body="{ data }">
                        <div style="display: flex; gap: 5px; align-items: center">
                            <button class="btn btn-sm btn-success" @click="guardar(data.idtrabajo)"><i class="fas fa-save"></i></button>
                            <button class="btn btn-sm btn-danger" @click="eliminar(data)"><i class="fas fa-trash"></i></button>
                        </div>
                    </template>
                </Column>

            </DataTable> 
        </div>
    </Dialog>
</template>
<script>
import FileUpload from 'primevue/fileupload';
import DataTable from 'primevue/datatable';
import Calendar from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import { PwgsApi } from '../../../../services/PwgsApi';
import { FilterMatchMode } from 'primevue/api';
export default {
    props:["id", "datos"],
    data(){
        return{
            urlglobal: localStorage.getItem('direccion'),
            archivoSubido:'',
            eliminar_especialidades_seleccionado:'',
            eliminar_seleccionado:'',
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            globalFilter:null,
            especialidades:[],
            nombre:'',
            fecha_inicio:'',
            fecha_fin:'',
            codigo:'',
            codrel:'',
            nomtr:'',
            preciocl:'',
            preciooper:'',
            preciolibre:false,
            solooper:false,
            app:false,
            cantidad:'',
            tipo:'',
            especialidad:'',
            trabajos:[],
            ordenarPor: 'codigo',
            codigotr:[],
            codreltr:[],
            nombretr:[],
            preciocltr:[],
            precioopertr:[],
            preciolibretr:[],
            soloopertr:[],
            apptr:[],
            cantidadtr:[],
            tipotr:[],
            especialidadtr:[],
            codigoOrdenAscendente:true,
            codigoIcon: 'fas fa-sort-down',
            nombreOrdenAscendente:false,
            nombreIcon: 'fas fa-sort-up',
            operario_factura_app: false,
            mostrar_tipo_trabajo_realizado: false
        }
    },
    components:{
        DataTable,
        Calendar,
        Dialog,
        FileUpload,
    },
    computed:{
        trabajosFiltrados(){
            if(this.trabajos){
                let filtrados = this.trabajos;
                 filtrados.sort((a, b) => {
                    if(this.ordenarPor == 'codigo') {                        
                        const valorA = a.codigo.toLowerCase();
                        const valorB = b.codigo.toLowerCase();
                        return this.codigoOrdenAscendente ? valorB.localeCompare(valorA) : valorA.localeCompare(valorB);                       
                    }else if(this.ordenarPor == 'nombre') {
                        const valorA = a.nombre.toLowerCase();
                        const valorB = b.nombre.toLowerCase();
                        return this.nombreOrdenAscendente ? valorB.localeCompare(valorA) : valorA.localeCompare(valorB); 
                    }
                });
                return filtrados;
            }else{
                return [];
            }
        },
        fechaInicioDate:{
            get() {
                if (!this.fecha_inicio) return null;
                // Si ya es un objeto Date, lo devolvemos tal cual
                if (this.fecha_inicio instanceof Date) {
                    return this.fecha_inicio;
                }
                // Parseamos "dd/mm/yyyy" a Date
                const [dia, mes, anio] = this.fecha_inicio.split('/');
                return new Date(anio, mes - 1, dia);
            },
            set(valor) {
                if (!valor) {
                    this.fecha_inicio = null;
                    return;
                }
                // Formateamos de vuelta a "dd/mm/yyyy" para guardar como antes
                const dia = String(valor.getDate()).padStart(2, '0');
                const mes = String(valor.getMonth() + 1).padStart(2, '0');
                const anio = valor.getFullYear();
                this.fecha_inicio = `${dia}/${mes}/${anio}`;
            }
        },
        fechaFinDate:{
            get() {
                if (!this.fecha_fin) return null;
                // Si ya es un objeto Date, lo devolvemos tal cual
                if (this.fecha_fin instanceof Date) {
                    return this.fecha_fin;
                }
                // Parseamos "dd/mm/yyyy" a Date
                const [dia, mes, anio] = this.fecha_fin.split('/');
                return new Date(anio, mes - 1, dia);
            },
            set(valor) {
                if (!valor) {
                    this.fecha_fin = null;
                    return;
                }
                // Formateamos de vuelta a "dd/mm/yyyy" para guardar como antes
                const dia = String(valor.getDate()).padStart(2, '0');
                const mes = String(valor.getMonth() + 1).padStart(2, '0');
                const anio = valor.getFullYear();
                this.fecha_fin = `${dia}/${mes}/${anio}`;
            }
        }    
    },
    methods:{
        marcarTodas(){
            if(confirm('¿Desea marcar todos los trabajos como precio libre?')){
                for(let trabajo of this.trabajos){
                    if(this.preciolibretr[trabajo.idtrabajo] == false){
                        this.guardar(trabajo.idtrabajo, true);
                    }
                }
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos marcados como precio libre', life: 2000 });
                this.obtenerTrabajos();
            }
        },
        descargar(){
            if(this.urlglobal == 'null.pwgs.app'){
                window.open('https://pwgs.raul.pwgs5.interno.apuyen.app/modulos/baremos/descargar_baremo.php?id_baremo='+this.$props.id,'_blank')
            }else{
                window.open('https://'+this.urlglobal+'/modulos/baremos/descargar_baremo.php?id_baremo='+this.$props.id,'_blank')
            }
        },
        async importar(){
            if(!this.archivoSubido){
                alert('Selecciona un archivo para importar.');
                return;
            }
            const api = new PwgsApi();
            const formData = new FormData();
            if(this.eliminar_seleccionado){
                formData.append('eliminar_baremo', this.eliminar_seleccionado);
            }
            if(this.eliminar_especialidades_seleccionado && this.eliminar_seleccionado != 'todo'){
                formData.append('eliminar_baremo_especialidades', this.eliminar_especialidades_seleccionado);
            }
            formData.append('archivo_csv_importar', this.archivoSubido);
            try{
                await api.post('baremos-pwgs/'+this.datos.id_baremo+'/importar-baremo',formData);
                this.$emit('datos-actualizados');
                
                    this.$toast.add({ severity: 'success', summary: 'Realizado', detail: 'Trabajos importados correctamente.', life: 2000 });
                    this.obtenerTrabajos();
            }catch(e) {
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
            }
        },
        subirarchivo(event) {
            this.archivoSubido = event.files[0];
        },
        async guardar(idtrabajo, todos_libre){
            const api = new PwgsApi();
            await api.put('baremos-pwgs/'+this.id+'/trabajo/'+idtrabajo,{codigo: this.codigotr[idtrabajo], precio:this.preciocltr[idtrabajo],
                cantidad: this.cantidadtr[idtrabajo], precio_operario: this.precioopertr[idtrabajo], libre_trabajo: todos_libre ? 1: this.preciolibretr[idtrabajo] ? 1:0,
                destinatario: this.soloopertr[idtrabajo] ? 'operario':'', codigo_relacion: this.codreltr[idtrabajo], app: this.apptr[idtrabajo]?1:0,
                tipo: this.tipotr[idtrabajo]});
            if(!todos_libre){
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajo modificado correctamente', life: 2000 });
                this.obtenerTrabajos();
            }
            
        },
        async eliminar(trabajo){
            const api = new PwgsApi();
            await api.delete('baremos-pwgs/'+this.id+'/trabajo/'+trabajo.idtrabajo);
            this.obtenerTrabajos();
        },
        async anadirTrabajo(){
            const api = new PwgsApi();
            if(this.nomtr == ''){
                alert('Debe introducir un nombre');
                return;
            }
            if(this.especialidad == ''){
                alert('Debe seleccionar una especialidad');
                return;
            }
            await api.post('baremos-pwgs/'+this.id+'/trabajo',{id_especialidad: this.especialidad, codigo:this.codigo, precio:this.preciocl, cantidad:this.cantidad,
                precio_operario:this.preciooper, libre_trabajo: this.preciolibre ? 1:0, destinatario: this.solooper ? 'operario':'', codigo_relacion: this.codrel,
                app: this.app ? 1:0, tipo: this.tipo, nombre:this.nomtr});
            this.codigo='';
            this.codrel = '';
            this.nomtr='',
            this.preciocl='',
            this.preciooper='',
            this.preciolibre=false,
            this.solooper=false,
            this.app=false,
            this.cantidad='',
            this.tipo='',
            this.especialidad='',
            this.obtenerTrabajos();
        },
        toggleOrden(campo) {
            this.ordenarPor = campo;
            if(campo == 'codigo'){
                this.codigoOrdenAscendente = !this.codigoOrdenAscendente;
                this.codigoIcon = this.codigoOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.nombreOrdenAscendente = false;
                this.nombreIcon = 'fas fa-sort-up'             
            }else if(campo == 'nombre'){
                this.nombreOrdenAscendente = !this.nombreOrdenAscendente;
                this.nombreIcon = this.nombreOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.codigoOrdenAscendente = false;
                this.codigoIcon = 'fas fa-sort-up'
            }
        },
        async guardarDatos(){
            const api = new PwgsApi();
            await api.put('baremos-pwgs/'+this.id, {nombre:this.nombre, fecha_inicio:this.fecha_inicio, fecha_fin: this.fecha_fin});
            this.$emit('datos-actualizados');
            this.$emit('update:visible')
        },
        async datosIniciales(){
            const api = new PwgsApi();
            this.nombre = this.datos.datos.nombre;
            this.fecha_inicio = this.parseDate(this.datos.datos.fecha_inicio);
            this.fecha_fin = this.parseDate(this.datos.datos.fecha_fin);
            //comprobar parametros mostrar_tipo_trabajo_realizado y operario_factura_app
            const parametro_tipo_trabajo = await api.get('parametros-pwgs/mostrar_tipo_trabajo_realizado');
            const parametro_operario_app = await api.get('parametros-pwgs/operario_factura_app');
            this.mostrar_tipo_trabajo_realizado = parametro_tipo_trabajo.mostrar_tipo_trabajo_realizado == '1' ? true : false;
            this.operario_factura_app = parametro_operario_app.operario_factura_app == '1' ? true : false;
        },
        parseDate(date){
            const [ano, mes, dia] = date.split("-");
            return `${dia}/${mes}/${ano}`;
        },
        async obtenerTrabajos(){
            const api = new PwgsApi();
            var espes = await api.get('/especialidades');
            espes.datos = espes.datos.sort((a, b) => a.nombre.localeCompare(b.nombre));
            this.especialidades = espes.datos;
            const trs = await api.post('baremos-pwgs/'+this.id+'/trabajos');
            this.trabajos = Object.values(trs);
            for(let trab of this.trabajos){
                var id = trab.idtrabajo;
                this.codigotr[id]=trab.codigo; 
                this.codreltr[id]=trab.codigo_relacion;
                this.nombretr[id]=trab.nombre;
                this.preciocltr[id]=trab.precio;
                this.precioopertr[id]=trab.precio_operario;
                this.preciolibretr[id]=trab.libre_trabajo=='1'?true:false;
                this.soloopertr[id]=trab.destinatario=='operario'?true:false;
                this.apptr[id]=trab.app=='1'?true:false;
                this.cantidadtr[id]=trab.cantidad;
                this.tipotr[id]=trab.tipo;
                this.especialidadtr[id]=trab.nombre_especialidad;
            } 
        }
    },
    mounted(){
        this.datosIniciales();
        this.obtenerTrabajos();
    },
    watch: {
        globalFilter(newFilter) {
            this.filters.global.value = newFilter;
        }
    }
}
</script>